import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, StatusBadge, Loading, Tag } from "@/components/common";
import { SquaresFour, VideoCamera, MapPin, CurrencyDollar, DotsSixVertical } from "@phosphor-icons/react";

const SCENES = [];

export default function Storyboard() {
  const { data: eps, loading } = useFetch("/episodes");
  if (loading) return <Loading />;
  const img = eps?.[0]?.image;

  return (
    <div>
      <PageHeader icon={SquaresFour} title="Storyboard"
        subtitle="Auto-generated storyboard cards for every scene. Drag to reorder. Each card shows camera, emotion, duration and estimated generation cost."
        badge={<Tag>{eps?.[0]?.title}</Tag>} />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SCENES.length === 0 && <Panel className="sm:col-span-2 lg:col-span-3"><p className="text-sm text-zinc-400">No storyboard generated yet. Real campaign scenes will appear here.</p></Panel>}
        {SCENES.map((s) => (
          <Panel key={s.n} data-testid={`scene-${s.n}`} className="p-0 overflow-hidden panel-hover">
            <div className="relative aspect-video">
              <img src={img} alt="" className="h-full w-full object-cover opacity-90" />
              <div className="absolute inset-0 scrim" />
              <span className="absolute top-2 left-2 font-mono text-xs bg-black/60 rounded px-2 py-0.5">SC {s.n}</span>
              <span className="absolute top-2 right-2 cursor-grab text-white/60"><DotsSixVertical size={18} /></span>
              <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                <StatusBadge status={s.status} />
                <span className="flex items-center gap-1 text-[11px] text-[#FFB800]"><CurrencyDollar size={12} weight="bold" />${s.cost.toFixed(1)}</span>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm text-white mb-2">"{s.dialogue}"</p>
              <div className="flex flex-wrap gap-2 text-[11px] text-zinc-400">
                <span className="flex items-center gap-1"><MapPin size={12} weight="duotone" />{s.loc}</span>
                <span className="flex items-center gap-1"><VideoCamera size={12} weight="duotone" className="text-[#00E5FF]" />{s.camera}</span>
                <Tag className="text-[10px]">{s.emotion}</Tag>
                <span>{s.dur}</span>
              </div>
            </div>
          </Panel>
        ))}
      </div>
    </div>
  );
}
